module.exports = __webpack_public_path__ + "img/alert.8596ea85.svg";